import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import debounce from 'lodash/debounce';
import { onMounted, ref, watch } from 'vue';
import { IVatTuResponseBase } from '@/core/interfaces/ApiResponses';
import { VatTuService } from '@/core/services/VatTu.service';
import { swalNotification } from '@/core/helpers/utils';
import { usePagination } from '@/core/hooks/use-pagination';
import { useLoading } from '@/core/hooks/use-loading';
import { usePageHeader } from '@/core/hooks/usePageHeader';
import DanhSachVatTuTable from '@/views/crafted/pages/vat-tu/danh-sach-vat-tu-table/DanhSachVatTuTable.vue';
import PageContentBase from '@/layout/_shared/PageContentBase.vue';
import Pagination from '@/components/shared/pagination/Pagination.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

document.title = 'Phê duyệt vật tư - Đường sắt Hà Nội';

const { currentPage, totalItems, perPage } = usePagination();
const { startLoading, endLoading } = useLoading();
const items = ref<IVatTuResponseBase[]>([]);

const { searchQuery } = usePageHeader({
  title: 'Phê duyệt vật tư',
  breadcrumbs: [
    { text: 'Phê duyệt' },
    { text: 'Vật tư' },
  ],
  showSearch: true,
  searchPlaceholder: 'Tìm vật tư theo mã hoặc tên',
});

const fetchVatTuItems = async () => {
  try {
    startLoading();

    const {
      data: {
        data: { data, total },
      },
    } = await VatTuService.list({
      per_page: perPage.value,
      current_page: currentPage.value,
      s: searchQuery.value,
      is_valid: 0,
    });

    totalItems.value = total;
    items.value = data;
    endLoading();
  } catch (e) {
    await swalNotification(
      'Có lỗi xảy ra khi lấy thông tin danh sách vật tư',
      'error'
    );
    endLoading();
  }
};

watch(
  () => currentPage.value,
  async () => {
    await fetchVatTuItems();
  }
);

watch(
  () => perPage.value,
  () => {
    if (currentPage.value === 1) {
      fetchVatTuItems();
      return;
    }
    currentPage.value = 1;
  }
);

watch(searchQuery, debounce(() => {
  fetchVatTuItems();
}, 500));

onMounted(async () => {
  await fetchVatTuItems();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageContentBase, null, {
    default: _withCtx(() => [
      _createVNode(DanhSachVatTuTable, {
        "cur-page": _unref(currentPage),
        items: items.value,
        "per-page": _unref(perPage),
        "show-approve-button": true,
        onDeleteVatTuSuccess: _cache[0] || (_cache[0] = ($event: any) => (fetchVatTuItems())),
        onOnApproveSuccess: _cache[1] || (_cache[1] = ($event: any) => (fetchVatTuItems()))
      }, null, 8, ["cur-page", "items", "per-page"]),
      (items.value.length > 0)
        ? (_openBlock(), _createBlock(Pagination, {
            key: 0,
            page: _unref(currentPage),
            "page-size": _unref(perPage),
            total: _unref(totalItems),
            onChangePage: _cache[2] || (_cache[2] = (value) => (currentPage.value = value)),
            onChangePageSize: _cache[3] || (_cache[3] = (value) => (perPage.value = value))
          }, null, 8, ["page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})